import { ApiErrorResponse } from '../api/common';

/**
 * Custom error class for API-related errors
 */
export class ApiError extends Error {
  public readonly status: number;
  public readonly response?: ApiErrorResponse;

  constructor(message: string, status: number, response?: ApiErrorResponse) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.response = response;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ApiError);
    }
  }
}
